import { render, staticRenderFns } from "./ThroughComponent.vue?vue&type=template&id=f049aade&scoped=true&"
import script from "./ThroughComponent.vue?vue&type=script&lang=js&"
export * from "./ThroughComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f049aade",
  null
  
)

export default component.exports